<template>
  <el-dialog
    :title="$t('config.account.assign.title.dialog3')"
    :visible.sync="dialogProductVisible"
    width="70%"
    :close-on-click-modal="false"
    @close="
      searchParams = { ...defaultSearchParams }
      assignProductForm = { ...defaultAssignProductForm }
      dialogProductVisible = false
    "
  >
    <div class="das-form-container">
      <div class="das-form-title-container">
        <div class="das-form-title">
          <div class="main-title">
            {{
              $t('config.account.assign.title.sub3_1', {
                txn: `(${txnSelected?.transaction_id} - ${txnSelected?.sub_transaction_id} - ${txnSelected?.sub_transaction_desc})`
              })
            }}
          </div>
        </div>
      </div>

      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label required">
                {{ $t('config.account.assign.field.business') }}
              </div>
              <div class="">
                <select-with-search-table
                  style="width: 100%"
                  index-field="business_district_id"
                  :search-fields="[
                    'business_district_id',
                    'business_district_code',
                    'business_district_name'
                  ]"
                  :selected-index-field-value="
                    assignProductForm.business_district_id
                  "
                  :value="assignProductForm.business_district_id"
                  :rows="businessRows"
                  :columns="businessCols"
                  :dropdown-width="600"
                  :is-remove-btn="true"
                  @selectionChanged="onSelectBusiness"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span>
                        {{
                          `${selectedData?.business_district_code || ''} - ${
                            selectedData?.business_district_name || ''
                          }`
                        }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div>
          </div>
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">
                <div class="checkbox-wrap">
                  <input
                    id="isShift"
                    v-model="assignProductForm.is_shift"
                    type="checkbox"
                    :disabled="isConfig"
                  />
                  <label
                    for="isShift"
                    style="color: #606266; font-size: 14px"
                    >{{ $t('config.account.assign.field.isShift') }}</label
                  >
                </div>
              </div>
              <div class="">
                <select-with-search-table
                  style="width: 100%"
                  index-field="id"
                  :search-fields="['id', 'name']"
                  :selected-index-field-value="assignProductForm.shift_id"
                  :value="assignProductForm.shift_id"
                  :rows="shiftRows"
                  :columns="shiftCols"
                  :dropdown-width="400"
                  :is-remove-btn="true"
                  :disabled="!assignProductForm.is_shift"
                  @selectionChanged="onSelectShift"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span>
                        {{
                          `${selectedData?.id || ''} - ${
                            selectedData?.name || ''
                          }`
                        }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="das-form-container" style="margin-top: 20px">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-6">
            <div class="das-form-title-container">
              <div class="das-form-title">
                <div class="main-title">
                  {{ $t('config.account.assign.title.sub3_2') }}
                </div>
              </div>
              <div class="button-containers">
                <button
                  class="btn primary medium"
                  @click="fnGetAvailableProducts"
                >
                  {{ $t('config.profile.searchBox.search') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-row">
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">
                {{ $t('config.account.assign.field.menu') }}
              </div>
              <div class="">
                <select-with-search-table
                  style="width: 100%"
                  index-field="id"
                  :search-fields="['id', 'name']"
                  :selected-index-field-value="searchParams.menuId"
                  :value="searchParams.menuId"
                  :rows="menuRows"
                  :columns="menuCols"
                  :dropdown-width="600"
                  :is-remove-btn="true"
                  @selectionChanged="onSelectMenu"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span>
                        {{
                          `${selectedData?.id || ''} - ${
                            selectedData?.name || ''
                          }`
                        }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div>
          </div>
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">
                {{ $t('config.account.assign.field.category') }}
              </div>
              <div class="">
                <Treeselect
                  v-model="searchParams.categoryId"
                  :multiple="false"
                  :close-on-select="true"
                  :searchable="true"
                  placeholder="Tìm kiếm..."
                  :options="optionsTree"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-row">
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">
                {{ $t('config.account.assign.field.productCodeOrName') }}
              </div>
              <div class="">
                <input v-model="searchParams.keyword" type="text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <MultiGridsTransfer
        :title1="$t('config.account.assign.title.sub3_3')"
        :title2="$t('config.account.assign.title.sub3_4')"
        :columns1="availableProductCols"
        :rows1="availableProductRows"
        :page1="page1"
        :is-row-selectable1="isRowSelectable1"
        :columns2="chosenProductCols"
        :rows2="chosenProductRows"
        :page2="page2"
        @transferData="updateChosenProduct"
        @pageChanged1="onPageChanged1"
        @pageChanged2="onPageChanged2"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="
            searchParams = { ...defaultSearchParams }
            assignProductForm = { ...defaultAssignProductForm }
            dialogProductVisible = false
          "
        >
          {{ $t('config.account.assign.btn.close') }}
        </button>
        <button class="btn primary small" @click="fnAssignProduct">
          {{ $t('config.account.assign.btn.submit') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Treeselect from '@riophae/vue-treeselect'
import {
  getBusinessProductAssign,
  getMenuByBusinessDistrict,
  getProductCategory,
  getAssignedProducts,
  getAvailableProducts,
  assignProduct
} from '@/api/configuration/accounting/assignBusinessDistrict'
import MultiGridsTransfer from './components/MultiPaginationGridsTransfer.vue'

const ASSIGN_PRODUCT_TXN_TYPE = 3

export default {
  components: {
    MultiGridsTransfer,
    Treeselect
  },
  props: {
    txnSelected: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      defaultAssignProductForm: {
        transaction_id: null,
        sub_transaction_id: null,
        business_district_id: null,
        shift_id: null,
        product_ids: [],
        type: null,
        is_shift: null
      },
      assignProductForm: {
        transaction_id: null,
        sub_transaction_id: null,
        business_district_id: null,
        shift_id: null,
        product_ids: [],
        type: null,
        is_shift: null
      },

      defaultSearchParams: {
        businessDistrictId: null,
        transactionId: null,
        subTransactionId: null,
        shiftId: null,
        menuId: null,
        categoryId: null,
        keyword: null,
        pageSize: null,
        pageNum: null
      },
      searchParams: {
        businessDistrictId: null,
        transactionId: null,
        subTransactionId: null,
        shiftId: null,
        menuId: null,
        categoryId: null,
        keyword: null,
        pageSize: null,
        pageNum: null
      },

      availableProductRows: [],
      chosenProductRows: [],

      // for select with search table
      businessRows: [],
      shiftRows: [],
      menuRows: [],

      dialogProductVisible: this.value,
      chosenBusinessDistrict: null,
      chosenShift: null,
      isConfig: false,
      isShiftConfig: false,
      chosenProducts: [],
      optionsTree: [],

      // pagination
      page1: {
        totalPage: null,
        pageSize: null,
        pageNum: null
      },
      page2: {
        totalPage: null,
        pageSize: null,
        pageNum: null
      }
    }
  },

  computed: {
    transactionId() {
      return this.txnSelected?.transaction_id
    },
    subTransactionId() {
      return this.txnSelected?.sub_transaction_id
    },

    availableProductCols() {
      return [
        {
          headerName: '',
          field: '',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('config.account.assign.field.productCode'),
          field: 'product_code'
        },
        {
          headerName: this.$t('config.account.assign.field.productName'),
          field: 'product_name'
        },
        {
          headerName: this.$t('config.account.assign.field.shift'),
          field: 'shift_description'
        }
      ]
    },
    chosenProductCols() {
      return [
        {
          headerName: '',
          field: '',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('config.account.assign.field.productCode'),
          field: 'product_code'
        },
        {
          headerName: this.$t('config.account.assign.field.productName'),
          field: 'product_name'
        }
      ]
    },

    businessCols() {
      return [
        {
          headerName: this.$t('config.account.assign.field.id'),
          field: 'business_district_id'
        },
        {
          headerName: this.$t(
            'config.account.assign.field.businessDistrictCode'
          ),
          field: 'business_district_code'
        },
        {
          headerName: this.$t(
            'config.account.assign.field.businessDistrictName'
          ),
          field: 'business_district_name'
        }
      ]
    },

    shiftCols() {
      return [
        { headerName: this.$t('config.account.assign.field.id'), field: 'id' },
        {
          headerName: this.$t('config.account.assign.field.shiftName'),
          field: 'name'
        }
      ]
    },
    menuCols() {
      return [
        { headerName: this.$t('config.account.assign.field.id'), field: 'id' },
        {
          headerName: this.$t('config.account.assign.field.menuName'),
          field: 'name'
        }
      ]
    }
  },

  watch: {
    value(nv, ov) {
      this.dialogProductVisible = nv
    },
    dialogProductVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    },
    transactionId(nv, ov) {
      if (nv) {
        this.fnGetBusinessProductAssign()
      }
    }
  },

  mounted() {
    this.fnGetProductCategory()
  },

  methods: {
    // util:
    changeKeyNames(obj) {
      // Base case: if the object is not an array or an object, return it as is
      if (!obj || typeof obj !== 'object') {
        return obj
      }

      // If the object is an array, iterate over its elements
      if (Array.isArray(obj)) {
        return obj.map(item => this.changeKeyNames(item))
      }

      // If the object is an object, iterate over its key-value pairs
      const newObj = {}
      for (const key in obj) {
        let newKey = null
        switch (key) {
          case 'name':
            newKey = 'label'
            newObj[newKey] = this.changeKeyNames(obj[key])
            // delete obj[key]
            break
          case 'children':
            if (obj[key].length <= 0) {
              // delete newObj[key]
            } else {
              newObj[key] = this.changeKeyNames(obj[key])
            }
            break
          default:
            newObj[key] = this.changeKeyNames(obj[key])
            break
        }
      }
      return newObj
    },
    isRowSelectable1(rowNode) {
      if (
        !this.assignProductForm.shift_id &&
        rowNode.data.configurations.length > 0
      ) {
        return false
      }
      if (this.assignProductForm.shift_id) {
        let check = false
        if (rowNode.data.configurations.length > 0) {
          for (let config of rowNode.data.configurations) {
            if (
              config.shift_id === null ||
              config.shift_id === this.assignProductForm.shift_id
            ) {
              check = true
              break
            }
          }
        }
        if (check) return false
      }
      return false
    },

    // handle event
    updateChosenProduct(row1, row2) {
      this.chosenProducts = row2
    },
    onPageChanged1(pageParams) {
      this.page1.pageSize = pageParams.pageSize
      this.page1.pageNum = pageParams.pageNum
      this.page1.totalPage = pageParams.totalPage
      this.fnGetAvailableProducts()
    },
    onPageChanged2(pageParams) {
      this.page2.pageSize = pageParams.pageSize
      this.page2.pageNum = pageParams.pageNum
      this.page2.totalPage = pageParams.totalPage
      this.fnGetAssignedProducts()
    },

    // select with search table
    onSelectBusiness(data) {
      // reset form
      this.searchParams = { ...this.defaultSearchParams }
      this.chosenBusinessDistrict = null
      this.chosenShift = null
      this.isConfig = this.isShiftConfig = false
      this.assignProductForm = { ...this.defaultAssignProductForm }
      this.availableProductRows = this.chosenProductRows = []

      this.chosenBusinessDistrict = data
      this.assignProductForm.business_district_id =
        data?.business_district_id || null

      if (this.assignProductForm.business_district_id) {
        this.fnGetMenuByBusinessDistrict()
        this.fnGetAvailableProducts()

        // get shift (if has)
        const chosenBusiness = this.businessRows.find(
          item =>
            this.assignProductForm.business_district_id ===
            item.business_district_id
        )
        this.shiftRows = chosenBusiness?.shifts

        this.isConfig = chosenBusiness?.is_configured
        this.isShiftConfig = chosenBusiness?.is_configured_by_shift
        this.assignProductForm.is_shift = this.isShiftConfig

        if (chosenBusiness?.is_configured) {
          if (!chosenBusiness?.is_configured_by_shift) {
            this.assignProductForm.shift_id = null
          } else {
            if (chosenBusiness?.shifts.length > 0) {
              this.assignProductForm.shift_id = chosenBusiness?.shifts[0].id
            } else {
              this.assignProductForm.shift_id = null
            }
          }

          this.fnGetAssignedProducts()
        }
      }
    },
    onSelectShift(data) {
      this.chosenShift = data
      this.assignProductForm.shift_id = data?.id || null

      // change shift => call api 4 getavailbleproduct
      this.searchParams = { ...this.searchParams }
      this.fnGetAvailableProducts()
    },
    onSelectMenu(data) {
      this.searchParams.menuId = data?.id || null
    },

    // handle api call
    fnGetBusinessProductAssign() {
      getBusinessProductAssign({
        transactionId: this.transactionId,
        subTransactionId: this.subTransactionId
      })
        .then(res => {
          if (!res.is_error) {
            this.businessRows = res.data
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnGetMenuByBusinessDistrict() {
      if (!this.assignProductForm.business_district_id) {
        // error
        return
      }
      getMenuByBusinessDistrict({
        businessDistrictId: this.assignProductForm.business_district_id
      })
        .then(res => {
          if (!res.is_error) {
            this.menuRows = res.data
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnGetProductCategory() {
      getProductCategory()
        .then(res => {
          if (!res.is_error) {
            this.optionsTree = this.changeKeyNames(res.data)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnGetAvailableProducts() {
      if (!this.assignProductForm.business_district_id) {
        return
      }
      this.searchParams = {
        ...this.searchParams,
        businessDistrictId: this.assignProductForm.business_district_id,
        transactionId: this.transactionId,
        subTransactionId: this.subTransactionId,
        shiftId: this.assignProductForm.shift_id,
        pageNum: this.page1.pageNum,
        pageSize: this.page1.pageSize
      }

      getAvailableProducts(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.availableProductRows = res.data
            this.page1.totalPage = Math.ceil(res.total / res.page_size)
            this.page1 = { ...this.page1 }
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnGetAssignedProducts() {
      if (!this.assignProductForm.business_district_id) {
        return
      }
      const searchParams = {
        businessDistrictId: this.assignProductForm.business_district_id,
        transactionId: this.transactionId,
        subTransactionId: this.subTransactionId,
        shiftId: this.assignProductForm.shift_id,
        pageNum: this.page2.pageNum,
        pageSize: this.page2.pageSize
      }

      getAssignedProducts(searchParams)
        .then(res => {
          if (!res.is_error) {
            this.chosenProductRows = res.data
            this.page2.totalPage = Math.ceil(res.total / res.page_size)
            this.page2 = { ...this.page2 }
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },

    fnAssignProduct() {
      // {
      //   "transaction_id": 0,
      //   "sub_transaction_id": 0,
      //   "business_district_id": 0,
      //   "shift_id": 0,
      //   "product_ids": [
      //     0
      //   ],
      //   "type": 0
      // }
      this.assignProductForm = {
        ...this.defaultAssignProductForm,
        transaction_id: this.transactionId,
        sub_transaction_id: this.subTransactionId,
        business_district_id: this.assignProductForm.business_district_id,
        shift_id: this.assignProductForm.shift_id,
        product_ids: this.chosenProductRows.map(row => row.id),
        type: ASSIGN_PRODUCT_TXN_TYPE // 3 ??
      }
      assignProduct(this.assignProductForm)
        .then(res => {
          if (!res.is_error) {
            this.$message({
              type: 'success',
              message: res.message // "assignTheDefaultTransactionToTheBusinessDistrictSuccessfully."
            })
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.searchParams = { ...this.defaultSearchParams }
          this.assignProductForm = { ...this.defaultAssignProductForm }
          this.dialogProductVisible = false
        })
    }
  }
}
</script>
